import { useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import Swal from './swal';
import RoadiesShell from './RoadiesShell';
import { GameHead, Modal, TopBar, useSaveScore } from './common';
import { useGameTimer, useRotateNotice } from './hooks';

const VALID_TEXT = ['the 12 lucky grapes', '12 lucky grapes', 'the twelve lucky grapes', 'twelve grapes of luck'];
const SWEET = '8';
const SOUR = '4';

// s5.php: name the Spanish grape tradition and count the sweet / sour grapes. 1 point each (max 3).
function Stage5Game() {
  const navigate = useNavigate();
  const { search } = useLocation();
  const game = useSelector((s) => s.roadies.game);
  const rotate = useRotateNotice();
  const timer = useGameTimer(true, game?.time);
  const save = useSaveScore();

  const base = game?.totalScore || 0;
  const [points, setPoints] = useState(base);
  const [text, setText] = useState('');
  const [sweet, setSweet] = useState('');
  const [sour, setSour] = useState('');
  const [hint, setHint] = useState(false);
  const busy = useRef(false);

  const textOk = VALID_TEXT.includes(text.trim().toLowerCase());
  const sweetOk = sweet.trim() === SWEET;
  const sourOk = sour.trim() === SOUR;

  const stateClass = (val, ok) => `rd-input ${val === '' ? '' : ok ? 'ok' : 'bad'}`;

  const submit = async () => {
    if (busy.current) return;
    if (text.trim() === '' || sweet.trim() === '' || sour.trim() === '') {
      Swal.fire('', 'Please fill all answers', 'info');
      return;
    }
    busy.current = true;
    const earned = (textOk ? 1 : 0) + (sweetOk ? 1 : 0) + (sourOk ? 1 : 0);
    const score = base + earned;
    setPoints(score);
    const result = await save(5, score, timer.current());
    if (result) navigate({ pathname: '/stage6', search });
    else busy.current = false;
  };

  return (
    <>
      {rotate && <div className="rd-rotate">Please rotate your device for the best experience</div>}
      <TopBar time={timer.text} points={points}>
        <button type="button" className="rd-link-btn" onClick={() => setHint(true)}>Hint</button>
      </TopBar>
      <GameHead title="Spain" />
      <div className="rd-game">
        <div className="rd-spain">
          <div className="rd-spain-col">
            Identify the name of this New Year tradition that originated in 1909 when a Spanish region had
            an exceptionally good grape harvest.
            <div className="rd-clue">Clue – las doce uvas de la suerte</div>
            <input
              type="text"
              className={stateClass(text, textOk)}
              placeholder="Answer"
              value={text}
              onChange={(e) => setText(e.target.value.replace(/^\s+/, ''))}
            />
          </div>
          <div className="rd-spain-col">
            <img src="/roadies/img/spain.gif" alt="Spain clock" />
          </div>
          <div className="rd-spain-col">
            This Spanish tradition consists of eating one grape at each hour until the clock strikes midnight
            on December 31 to welcome the New Year. Count the number of sweet and sour grapes in the clock!
            <div className="rd-grapes">
              <label>
                Sweet Grapes
                <input
                  className={`${stateClass(sweet, sweetOk)} rd-input-sm`}
                  value={sweet}
                  onChange={(e) => setSweet(e.target.value.replace(/^\s+/, ''))}
                />
              </label>
              <label>
                Sour Grapes
                <input
                  className={`${stateClass(sour, sourOk)} rd-input-sm`}
                  value={sour}
                  onChange={(e) => setSour(e.target.value.replace(/^\s+/, ''))}
                />
              </label>
            </div>
          </div>
        </div>
        <div>
          <button type="button" className="rd-btn" onClick={submit}>Submit</button>
        </div>
      </div>
      {hint && (
        <Modal title="Hint" onClose={() => setHint(false)}>
          This New Year's tradition involves eating one grape with each clock strike at midnight for good
          luck. It is also called "Las Doce Uvas de la Suerte" in Spanish.
        </Modal>
      )}
    </>
  );
}

export default function RoadiesStage5() {
  return (
    <RoadiesShell bg="spain.jpg" bgMob="spain-mob.jpg" stage={5} className="rd-stage rd-stage5">
      <Stage5Game />
    </RoadiesShell>
  );
}
